import { addDays } from 'date-fns';
import { Pagination } from '../../model/pagination';
import { configs } from '../../app/app-configs';
import { KeyValuePair } from '../../model/key-value-pair';

export interface Product {
    id: number;
    name: string;
    description: string;
    totalStock: number;
    lowStockThreshold: number;
    imageUrl: string;
    batches: ProductBatch[];
}

export interface ProductRequest {
    id?: number;
    name: String;
    description: String;
    lowStockThreshold: number;
    imageUrl: string;
}

export interface ProductAndBatchId {
    productId: number;
    batchId: number;
}

export interface ProductSummary {
    totalProducts: number;
    lowStockProducts: number;
    outOfStockProducts: number;
    expiredProducts: number;
}

export interface ProductBatch {
    id: number;
    productId: number;
    batchCode: string;
    receivedDate: string;
    costPrice: number;
    sellingPrice: number;
    quantityReceived: number;
    quantityInStock: number;
    expiryDate: string;
}

export interface ProductBatchRequest {
    id?: number;
    productId: number;
    batchCode: string;
    receivedDate: string;
    costPrice: number;
    sellingPrice: number;
    quantityReceived: number;
    expiryDate: string;
}

export interface SaleItem {
    id: number;
    product: Product;
    productBatch: ProductBatch;
    totalAmount: number;
    quantity: number;
    costPrice: number;
    sellingPrice: number;
}

export interface SaleItemRequest {
    id?: number;
    saleId?: number;
    productId: number;
    productBatchId: number;
    quantity: number;
    costPrice: number;
    sellingPrice: number;
}

export interface Sale {
    id: number;
    memberId?: number;
    // memberName: string;
    saleDate: string;
    saleItems: SaleItem[];
}

export interface SaleSummary {
    thisMonthSales: number;
    thisMonthProfit: number;
    itemsSoldToday: number;
    todaySales: number;
    salesTrend: KeyValuePair<number>[];
    profitTrend: KeyValuePair<number>[];
    profitableProducts: KeyValuePair<number>[];
}

export interface SaleRequest {
    id?: number;
    memberId?: number;
    totalAmount: number;
    saleDate: string;
    saleItems: SaleItemRequest[];
}

export interface SaleSearchCriteria {
    pagination: Pagination;
    from: string;
    to: string;
    name: string;
}

export const getDefaultSaleSearchCriteria = (): SaleSearchCriteria => {
    return {
        pagination: { page: 0, size: configs.PAGE_SIZE },
        name: '',
        from: addDays(new Date(), -7).toISOString().slice(0, 10),
        to: new Date().toISOString().slice(0, 10),
    };
};
